module.exports = __webpack_public_path__ + "instruction-virtual-good.141f33d7.png";